"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns custom Apple Pay error.
 * Usually when paymentStatus is not SUCCESS for /checkout/payment call
 * @returns
 */
const getApplePayCustomError = () => {
    return {
        response: {
            data: {
                code: 'APPL404',
                desc: 'Apple pay failed',
            },
            status: 404,
        },
    };
};
exports.default = getApplePayCustomError;
